import Subtitle from '../titles/Subtitle'

const YearMonthForm = ({ date, locale }) => {
  const month = date.toLocaleString(locale, { month: 'long' })
  const capitalizedMonth = `${month.charAt(0).toUpperCase()}${month.substring(1)}`

  return (
    <div className='DayPicker-Caption'>
      <Subtitle textAlign={'left'} fontSize={'11px'}>
        {date.getFullYear()}
      </Subtitle>
      <div
        id='month'
        style={{
          color: '#2c3037',
          fontWeight: 'normal',
          fontSize: '20px',
          textTransform: 'capitalize'
        }}>
        {capitalizedMonth}
      </div>
      <hr
        style={{
          margin: '17px -24px 12px -24px',
          borderTop: 'none',
          borderLeft: 'none',
          borderColor: '#e9eaeb'
        }}
      />
    </div>
  )
}

export default YearMonthForm
